<template>
    <div class="nav-wrapper">
        <el-row>
            <el-col :span="20" :offset="2">
                <div class="nav">
                    <el-menu :default-active="$route.meta.nav" :router="true" class="el-menu-demo" mode="horizontal"  active-text-color="#6794eb">
                        <el-menu-item index="/">
                            <div id="logo-img">
                                <img src="../../../assets/logo.jpg" alt="">
                            </div>
                        </el-menu-item>
                        <el-menu-item index="/salary/new">发送工资条</el-menu-item>
                        <el-menu-item index="/salary/records">历史记录</el-menu-item>
                        <el-menu-item index="/salary/analytic">成本分析</el-menu-item>
                        <el-menu-item index="/salary/help">帮助中心</el-menu-item>

                        <!--<el-menu-item index="/salary/message" :class="{ right: true}">消息</el-menu-item>-->
                        <el-submenu index="5" :class="{ right: true}">
                            <template slot="title">我的</template>
                            <el-menu-item index="/salary/account">账号配置</el-menu-item>
                            <!--<el-menu-item index="/price">服务价格</el-menu-item>-->
                            <el-menu-item index="/logout">退出</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
	export default {
		name: "Navbar",
		created() {
			console.log('nav:' + this.$route.meta.nav);
        }
	}
</script>

<style scoped>

    .nav-wrapper {
        z-index: 100;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: #fff;
    }

    .el-menu--horizontal>.right {
        float: right;
    }

    #logo-img, #logo-txt {
        display: inline-block;
        float: left;
        height: 61px;
        line-height: 61px;
    }

    #logo-img img {
        height: 40px;
    }

    #logo-txt {
        margin-left: 4px;
        font-size: 14px;
    }

    #logo-txt, #logo-txt span {
        display: inline-block;
        color: #5a8ceb;
        height: 60px;
        line-height: 60px;
    }

    .el-menu-item {
        padding: 0 10px;
    }

    .el-row {
         margin-bottom: 0 !important;
    }

    .el-menu--horizontal {
        border-right: none;
        border-bottom: none !important;
    }

    .is-opened .el-menu--horizontal>.el-submenu:focus .el-submenu__title, .el-menu--horizontal>.el-submenu:hover .el-submenu__title {
        color: #6794eb;
    }
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue